Ext.define('SA.lq.ExportRequestFactory', {
    constructor({model, countryCode, censusReleaseYear, resultLimit, baseColumns}) {
        this.model = model;
        this.countryCode = countryCode;
        this.censusReleaseYear = censusReleaseYear;
        this.resultLimit = resultLimit;
        this.baseColumns = baseColumns;
    },

    createExportRequest({state, deliveryType, fileExtension, emailAddress, emailMessage}) {
        SA.Exports.export({
            model: this.model,
            resource: 'data/location',
            isDownload: deliveryType === 'download',
            extension: fileExtension,
            emailParams: {address: emailAddress, message: emailMessage},
            params: this.getDataParams({state})
        });
    },

    async createLimitCheckRequest(state) {
        var response = await SA.Ajax.request({
            method: 'check',
            resource: 'data/locationLimits',
            data: this.getDataParams({state})
        });

        return Object.entries(response).map(entry => {
            var [datasetName, {proposedUsage, weekly, yearly}] = entry,
                weeklyUsage = new SA.lq.DatasetExportIntervalUsage({
                    limit: weekly.limit,
                    currentTotalUse: weekly.used,
                    proposedTotalUse: weekly.used + proposedUsage
                }),
                yearlyUsage = new SA.lq.DatasetExportIntervalUsage({
                    limit: yearly.limit,
                    currentTotalUse: yearly.used,
                    proposedTotalUse: yearly.used + proposedUsage
                });

            return new SA.lq.DatasetExportUsage({datasetName, weeklyUsage, yearlyUsage});
        });
    },

    getDataParams({state}) {
        var location = state.getSelectedLocationModel(),
            geoUnitId = state.getSelectedGeoUnitId(),
            sortModel = state.getSortModel(),
            filter = state.getConditionList().toPredicateWithNotNulls().serialize();

        return {
            slice: [0, this.resultLimit],
            sort: sortModel.hasAttributeId('name') ? [sortModel.toTuple()] : [sortModel.toTuple(), ['asc', 'name']],

            ...(filter === null ? {} : {filter}),

            locationSeries: SA.Predicate.and([
                SA.Predicate.equal('censusRelease', this.censusReleaseYear),
                SA.Predicate.equal('geographicUnit', geoUnitId),
                SA.Predicate.withinOrRadius({location, geoUnitId})
            ]).serialize(),

            select: SA.Exports.getColumnExpressions({
                country: this.countryCode,
                geographicUnit: geoUnitId,
                baseColumns: this.baseColumns,
                attributes: state.getConditionList().getUniqueAttributeIds()
            })
        };
    }
});